type RouteMatch = { route: { path?: string } };

/** A `matchRoutes` bound to an app's route tree, e.g. `(loc) => matchRoutes(routes, loc)`. */
export type RouteMatcher = (location: { pathname: string }) => RouteMatch[] | null;

/** React Router's matched route pattern for a path (`/classes/:classId`), or the raw path when
 * nothing matches. Kept free of React imports so non-hook telemetry can use it too. */
export function getRoutePattern(pathname: string, matchRoutes: RouteMatcher): string {
  const matches = matchRoutes({ pathname });
  if (!matches?.length) return pathname;
  // A layout route with path "/" is truthy but contributes nothing, and joining it in would
  // produce a "//" prefix.
  return `/${matches
    .map((m) => m.route.path)
    .filter((path): path is string => !!path && path !== "/")
    .join("/")}`;
}
